import { handleApiError } from "./handleApiError";
import instance from './index';

type TGetUser = {
  token?: string,
};

type TUserData = {
  id: string,
  phoneNumber?: string,
  firstName: string,
  lastName: string,
  serviceAreaId: string,
  serviceAddress?: string,
  serviceLatitude?: number,
  serviceLongitude?: number,
}

type TGetAllUsers = {
  page?: number,
  limit?: number,
  orderBy?: string
};

type TSuspendUser = {
  id: string;
  suspend: boolean;
}

type TPatchPassword = {
  oldPassword: string,
  password: string,
  passwordConfirm: string,
}

type TAdminUpdateUser = {
  id: string;
  email?: string;
  phoneNumber?: string;
  firstName?: string;
  lastName?: string;
  serviceAreaId?: string;
  verified?: boolean;
  disabled?: boolean;
};

type TAdminPassword = {
  id: string;
  sendResetEmail?: boolean;
  password?: string;
};

export const getUserData = async ({ token }: TGetUser) => {
  try {
    const response = await instance.get(`/user/me`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    return response.data;
  } catch (error: unknown) {
    handleApiError(error);
  }
}

export const updateUserData = async ({
  id,
  phoneNumber,
  firstName,
  lastName,
  serviceAreaId,
  serviceAddress,
  serviceLatitude,
  serviceLongitude,
}: TUserData) => {
  try {
    const response = await instance.patch(`/user/${id}`, {
      phoneNumber,
      firstName,
      lastName,
      serviceAreaId,
      ...(serviceAddress ? { serviceAddress, serviceLatitude, serviceLongitude } : {}),
    });
    return response.data;
  } catch (error: unknown) {
    handleApiError(error);
  }
};

export const getServiceAreas = async () => {
  try {
    const response = await instance.get(`/user/service-area`);

    return response.data;
  } catch (error: unknown) {
    handleApiError(error);
  }
}


export const getUsers = async ({
  page = 1,
  limit = 12,
  orderBy = 'startDate-asc',
}: TGetAllUsers) => {
  try {

    const response = await instance.get(`/user`,
      {
        params: {
          orderBy,
          page,
          limit,
        }
      }
    );
    return response.data;
  } catch (error: unknown) {
    handleApiError(error);
  }
};

export const getUserById = async (id: string) => {
  try {
    const response = await instance.get(`/user/${id}`);
    return response.data;
  } catch (error: unknown) {
    handleApiError(error);
  }
};

export const adminUpdateUser = async ({ id, ...data }: TAdminUpdateUser) => {
  try {
    const response = await instance.patch(`/user/${id}/admin`, data);
    return response.data;
  } catch (error: unknown) {
    handleApiError(error);
  }
};

export const adminPassword = async ({ id, sendResetEmail, password }: TAdminPassword) => {
  try {
    const response = await instance.post(`/user/${id}/admin-password`, {
      sendResetEmail,
      password,
    });
    return response.data;
  } catch (error: unknown) {
    handleApiError(error);
  }
};

export const forcePasswordReset = async (id: string) => {
  try {
    const response = await instance.post(`/user/${id}/force-password-reset`);
    return response.data;
  } catch (error: unknown) {
    handleApiError(error);
  }
};

export const suspendUser = async ({ id, suspend }: TSuspendUser) => {
  try {
    const response = await instance.patch(`/user/suspend/${id}?suspend=${suspend}`);
    return response.data;
  } catch (error: unknown) {
    handleApiError(error);
  }
};

export const passwordPatch = async ({ oldPassword, password, passwordConfirm }: TPatchPassword) => {
  try {
    await instance.patch(`/user/password`, { 
      oldPassword, 
      password, 
      passwordConfirm
    });
  } catch (error: unknown) {
    handleApiError(error);
  }
};
